import api from "../util/api";
import { notifyWarn, notifySuccess, notifyInfo } from "../components/message/message";
import * as actions from "../store/modules/tipoFormalizacaoInstituicao/actions";
import { setLoading } from "../store/modules/globalLoading/actions";

export async function get() {

    setLoading(true)
    const data = await api.get(`TipoFormalizacaoBanco`);
    setLoading(false)

    if (!data.success) {
        return;
    }

    actions.getTipos(data.content);
}

export async function getById(id) {

    setLoading(true)
    const data = await api.get(`TipoFormalizacaoBanco/${id}`);
    setLoading(false)

    if (!data.success) {
        return;
    }

    actions.copy(data.content);
    actions.setItem('id', data.content.id);
    actions.setItem('descricao', data.content.descricao);
    actions.setItem('instituicaoId', data.content.bancoId);
    actions.setItem('tipoFormalizacaoId', data.content.tipoFormalizacao.id);
}

export async function create(item) {

    if (item.descricao.trim() === "") {
        actions.setInvalid("descricao");
        notifyWarn("Descrição não pode estar em branco");
        return;
    }

    if (item.instituicaoId === '0') {
        actions.setInvalid("instituicaoId");
        notifyWarn("Instituição não pode estar em branco");
        return;
    }
    if (item.tipoFormalizacaoId === '0') {
        actions.setInvalid("tipoFormalizacaoId");
        notifyWarn("Tipo formalização não pode estar em branco");
        return;
    }

    const body = {
        descricao: item.descricao,
        bancoId: item.instituicaoId,
        tipoFormalizacaoId: item.tipoFormalizacaoId,
    }

    setLoading(true)
    const data = await api.post(`TipoFormalizacaoBanco`, body);
    setLoading(false)

    if (!data.success) {
        return;
    }

    notifySuccess("Tipo de Formalização instituição cadastrado");
    actions.cleanRegister();
    get();
}

export async function remove(id) {

    setLoading(true)
    const data = await api.delete(`TipoFormalizacaoBanco/${id}`);
    setLoading(false)

    if (!data.success) {
        return;
    }

    notifySuccess("Tipo de formalização instituição removido");
    get();
}

export async function update(item, copy) {

    if (JSON.stringify(item) === JSON.stringify(copy)) {
        notifyInfo("Nada foi alterado");
        return;
    }

    if (item.descricao.trim() === "") {
        actions.setInvalid("descricao");
        notifyWarn("Descrição não pode estar em branco");
        return;
    }

    if (item.instituicaoId === '0') {
        actions.setInvalid("instituicaoId");
        notifyWarn("Instituição não pode estar em branco");
        return;
    }
    if (item.tipoFormalizacaoId === '0') {
        actions.setInvalid("tipoFormalizacaoId");
        notifyWarn("Tipo formalização não pode estar em branco");
        return;
    }

    const body = {
        descricao: item.descricao,
        bancoId: item.instituicaoId,
        tipoFormalizacaoId: item.tipoFormalizacaoId,
    }

    setLoading(true)
    const data = await api.put(`TipoFormalizacaoBanco/${item.id}`, body);
    setLoading(false)

    if (!data.success) {
        return;
    }

    notifySuccess("Tipo de formalização instituição atualizado");
    actions.cleanRegister();
    actions.setActiveTab("Search");
    get();
}

export async function getInstituicoes() {

    const data = await api.get("bancos");

    if (!data.success) {
        return;
    }

    actions.getInstituicoes(data.content);
}

export async function getTiposFormalizacoes() {

    const data = await api.get("TipoFormalizacao");

    if (!data.success) {
        return;
    }

    actions.getTiposFormalizacoes(data.content);
}
